/**
 * Misan Oyuncak - Playful Luxury Animations
 * Uses IntersectionObserver to trigger fade-up animations on scroll without heavy JS libraries.
 */
document.addEventListener('DOMContentLoaded', () => {
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.15
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('misan-animate-in');
        observer.unobserve(entry.target); // Only animate once
      }
    });
  }, observerOptions);

  // Select all elements that need to fade up
  const animatedElements = document.querySelectorAll('.misan-fade-up, .misan-product-card, .misan-trust-badge');
  
  animatedElements.forEach(el => {
    observer.observe(el);
  });

  // Sticky Add-To-Cart logic for Product Pages
  const stickyCart = document.querySelector('.misan-sticky-cart');
  const mainAddToCart = document.querySelector('.product-form__submit');
  
  if (stickyCart && mainAddToCart) {
    const cartObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          // Main button is out of view, show sticky cart
          stickyCart.classList.add('is-visible');
        } else {
          // Main button is in view, hide sticky cart
          stickyCart.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });
    
    cartObserver.observe(mainAddToCart);
  }
});
